import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function LinkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 4.25001L11.25 0.750006M11.25 0.750006H7.74999M11.25 0.750006L6 6M4.83333 0.75H3.55C2.56991 0.75 2.07986 0.75 1.70552 0.940739C1.37623 1.10852 1.10852 1.37623 0.940739 1.70552C0.75 2.07986 0.75 2.56991 0.75 3.55V8.45C0.75 9.43009 0.75 9.92014 0.940739 10.2945C1.10852 10.6238 1.37623 10.8915 1.70552 11.0593C2.07986 11.25 2.56991 11.25 3.55 11.25H8.45C9.43009 11.25 9.92014 11.25 10.2945 11.0593C10.6238 10.8915 10.8915 10.6238 11.0593 10.2945C11.25 9.92014 11.25 9.43009 11.25 8.45V7.16667"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
